/* eslint-disable no-unused-vars */
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import makeWhiteLogo from "assets/img/make-white.png";
import makeLogo from "assets/img/make.png";

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/landingPage.js";

// Sections for this page
import ProductSection from "./Sections/ProductSection.js";
import WhatForSection from "./Sections/WhatForSection.js";
import WorkSection from "./Sections/WorkSection.js";
import MethodSection from "./Sections/MethodSection.js";
import ResultsSection from "./Sections/ResultsSection.js";

const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function LandingPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        brand="Make"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
          logo: makeLogo
        }}
        {...rest}
      />
      <Parallax filter image={require("assets/img/landing-make.jpg")}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <h1 className={classes.title}>La estrategia de la región comienza aquí.</h1>
              <h4>
                Solo bajo la senda del conocimiento y la innovación se dibuja la ruta hacia el futuro de las regiones. Un camino que requiere recursos que permitan trazar el mejor posicionamiento con el que garantizar el progreso y bienestar social.
              </h4>
{/*               <br />
              <Button
                color="danger"
                size="lg"
                href="https://www.youtube.com/watch?v=DkvRV7FcRrk"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-play" />
                {'  '} Ver video
              </Button> */}
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <ProductSection />
          <WhatForSection />
          <MethodSection />
          <ResultsSection />
          <WorkSection />
        </div>
      </div>
      <Footer />
    </div>
  );
}
/* eslint-disable no-unused-vars */